import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getRequestToken, getAccessToken } from '../../actions';
import MALogo from '../../components/LoginForm/MALogo';
import LoginWithMotorsportRegButton from '../../components/LoginForm/LoginWithMotorsportRegButton';
import '../../../html/assets/stylesheets/theme.scss';
import '../../../html/assets/stylesheets/sprites/ico-sprite.scss';
import hasStorage from '../../store/hasStorage'

class App extends Component {

  componentDidMount() {
    const {location, user, getAccessToken} = this.props;
    const {oauth_verifier, oauth_token} = location.query;

    if (oauth_verifier && (oauth_token === user.oauthToken)) {
      getAccessToken(oauth_verifier);
    }
  }

  render() {
    const {getRequestToken} = this.props;

    var isStorageEnabled = hasStorage('localStorage');
    
    return (
      <div className="container">
        <MALogo />
        {!isStorageEnabled && 
          <div>
            <div className="alert alert-form-error">Your browser is refusing cookies which you need to log in. Please follow these directions to <a href='http://help.motorsportreg.com/article/442-how-to-enable-cookies-and-localstorage-in-web-browsers'>enable cookies and local storage</a></div>
            <hr />
          </div>
        }
        <LoginWithMotorsportRegButton getRequestToken={getRequestToken} />
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    user: state.user,
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getRequestToken, getAccessToken }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js